export default __webpack_public_path__ + "static/media/favicon.60106da4.ico";